export const styles = {
	container: {
		border: '1px dashed #D9D9D9',
		borderRadius: '9px',
		dropShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
		cursor: 'pointer',
	},
	items: {
		border: '10px solid transparent',
	},
};
